module.exports = __webpack_public_path__ + "static/img/slider2.f8d2d61.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider2.jpeg
// module id = qTUs
// module chunks = 1